import React from 'react'
import styles from '../Proj2Folder/Proj2.module.css'
import ksa from '../../Images/ksa.jpg'



export default function Mekka() {
  return (

    <>
        <div className="container my-5 py-5 ">
          <div className="row  align-items-center">
            <div className="col-md-6">
                <h3 className={`${styles.color} my-3`}> AL HIJRAH RESIDENTIAL & COMMERCIAL COMPLEX, MAKKAH, KSA ​</h3>
                <p> Project description: Residential and Commercial </p>
                <p>Type of contract: Design </p>
                <p> Area:  40000 m2 </p>
                <p>Type of works : Architectural coordination's and Electromechanical </p>
            </div>
            <div className="col-md-6 text-center">
                <img src={ksa} alt="achegy" className='img-fluid'/>
            </div>   
          </div>

        </div>

    </>
  )
}
